import * as commonTypes from './commonTypes'
import * as kanbanTypes from './kanbanTypes'
import * as linkTypes from './linkTypes'
import * as mustReadTypes from './mustReadTypes'
import * as taskTypes from './taskTypes'

interface AllowedStoryActionTypes {
    commonTypes: typeof commonTypes,
    kanbanTypes: typeof kanbanTypes,
    linkTypes: typeof linkTypes,
    mustReadTypes: typeof mustReadTypes,
    taskTypes: typeof taskTypes
}
export const allowedStoryActionTypes: AllowedStoryActionTypes = {
    commonTypes,
    kanbanTypes,
    linkTypes,
    mustReadTypes,
    taskTypes
}
type AllowedStoryActionTypesValues = string[]
export const allowedStoryActionTypesValues: AllowedStoryActionTypesValues = Object.values(allowedStoryActionTypes).reduce((accum: string[], type: {}) => [...accum, ...Object.values(type)], [])